import { combineReducers } from 'redux';

import * as $app from 'modules/app';
import { influencerListReducer } from './reducers/influencerList';

const influencersReducerBase = combineReducers({
  list: influencerListReducer,
});

export const influencersReducer = (state, action) => {
  if (action.type === $app.reset().type) {
    state = undefined;
  }

  return influencersReducerBase(state, action);
};
